module.exports = __webpack_public_path__ + "img/green-leaves-bottom.55fae5ff.png";